<template>
  <div class="recycle-header-component">
    <div class="header">
      <div class="header-content box">
        <img class="icon-logo" src="./img/icon_logo_260318.png" />
        <div class="about-content">
          <div class="about-item" @click="openBoss">加入我们</div>
          <el-popover
            placement="bottom"
            trigger="hover"
            :visible-arrow="false"
            :close-delay="0"
          >
            <div class="home-help-center">
              <img class="icon-mini-qrcode" :src="helpCenter.qrcode" />
            </div>
            <div slot="reference" class="about-item" @click="$emit('help', helpCenter)">帮助中心</div>
          </el-popover>
          <div class="about-item" @click="openAboutUs">关于我们</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popover } from 'element-ui';

export default {
  components: {
    [Popover.name]: Popover
  },
  data () {
    return {
      helpCenter: {
        name: 'wechatmini_help_center',
        title: '微信小程序帮助中心',
        titleIcon: require('./img/icon_wechatmini_faq_title.png'),
        qrcode: require('./img/icon_wechatmini_faq.png')
      }
    };
  },
  methods: {
    popoverChange (item) {
      item.show = !item.show;
    },
    openBoss () {
      window.open('https://www.zhipin.com/gongsi/4297937bda642bcf1nd829y8.html?ka=search_rcmd_company_4297937bda642bcf1nd829y8_custompage', '_blank');
    },
    openAboutUs () {
      window.open('/about', '_blank');
    }
  }
};
</script>

<style scoped>
.header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  background: #ffed3b;
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    .icon-logo {
      width: 111px;
      height: 40px;
    }
    .about-content {
      display: flex;
      font-size: 14px;
      color: #2c2c2c;
      .about-item {
        position: relative;
        margin-left: 60px;
        cursor: pointer;
        &:hover {
          font-weight: bold;
          &::after {
            position: absolute;
            content: '';
            left: 50%;
            bottom: -12px;
            margin-left: -15px;
            width: 30px;
            height: 4px;
            background: #2c2c2c;
            border-radius: 2px;
          }
        }
      }
    }
  }
}
.home-help-center {
  padding-top: 10px;
  .icon-mini-qrcode {
    width: 180px;
    height: 180px;
  }
}
.box {
  margin: 0 auto;
  width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/recycle-header.vue